"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var uuid_1 = require("uuid");
var firebase = __importStar(require("firebase/app"));
var onboarding_web_1 = require("@21st-night/onboarding-web");
var core_1 = require("@21st-night/core");
var hooks_1 = require("material-ui-popup-state/hooks");
var core_2 = require("@material-ui/core");
var ArrowDropDownRounded_1 = __importDefault(require("@material-ui/icons/ArrowDropDownRounded"));
var slate_1 = require("slate");
var editor_web_1 = require("@21st-night/editor-web");
var cards_web_1 = require("@21st-night/cards-web");
var Button_1 = __importDefault(require("../../Button"));
var ImportCardsDialog_1 = __importDefault(require("../ImportCardsDialog"));
var CardFormContainer_1 = __importDefault(require("../CardFormContainer"));
var DeckImportFromQuizletContainer_1 = __importDefault(require("../../Deck/DeckImportFromQuizletContainer"));
var CreateCardFormContainer = function (_a) {
    var resetOnSuccess = _a.resetOnSuccess, onCancel = _a.onCancel, onSuccess = _a.onSuccess, other = __rest(_a, ["resetOnSuccess", "onCancel", "onSuccess"]);
    var _b = core_1.useCardForm(), reset = _b.reset, setValue = _b.setValue;
    var deck = core_1.useDeck();
    var user = core_1.useUser();
    var _c = core_1.useFirebase(), db = _c.db, storage = _c.storage, functions = _c.functions;
    var uploads = core_1.useUploads().uploads;
    var _d = __read(react_1.useState(false), 2), loading = _d[0], setLoading = _d[1];
    var _e = __read(react_1.useState(false), 2), importDialogOpen = _e[0], setImportDialogOpen = _e[1];
    var _f = __read(react_1.useState(false), 2), quizletDialogOpen = _f[0], setQuizletDialogOpen = _f[1];
    var _g = __read(react_1.useState(false), 2), csvDialogOpen = _g[0], setCsvDialogOpen = _g[1];
    var _h = __read(react_1.useState(false), 2), snackbarOpen = _h[0], setSnackbarOpen = _h[1];
    var _j = __read(react_1.useState(''), 2), snackbarMessage = _j[0], setSnackbarMessage = _j[1];
    var logEvent = core_1.useAnalytics().logEvent;
    var _k = __read(core_1.useTimeActive(30), 1), time = _k[0];
    var importMenuPopupState = hooks_1.usePopupState({
        variant: 'popover',
        popupId: 'import-menu-popup',
    });
    react_1.useEffect(function () {
        if (deck.filterCategory) {
            setValue('category', deck.filterCategory);
        }
        if (deck.filterSubcategories.length) {
            setValue('subcategories', deck.filterSubcategories);
        }
    }, [deck.filterCategory, deck.filterSubcategories, setValue]);
    function handleSubmit(values, note) {
        return __awaiter(this, void 0, void 0, function () {
            var cardId, editor, isInline_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, deck.addCard(values)];
                    case 1:
                        cardId = _a.sent();
                        if (values.note && note) {
                            if (note) {
                                editor = slate_1.createEditor();
                                isInline_1 = editor.isInline;
                                editor.isInline = function (node) { return node.type === 'card-link' || isInline_1(node); };
                                editor.children = note.content;
                                slate_1.Transforms.wrapNodes(editor, { type: 'card-link', cardId: cardId, children: [] }, {
                                    split: true,
                                    at: note.selection,
                                });
                                db.collection('notes')
                                    .doc(values.note)
                                    .update({
                                    content: editor_web_1.serializeDocument(editor.children),
                                    cards: firebase.firestore.FieldValue.arrayUnion(cardId),
                                });
                            }
                        }
                        if (user.onboarding &&
                            !user.onboarding.completed &&
                            (typeof user.onboarding === 'undefined' ||
                                (user.onboarding && !user.onboarding.completedSteps) ||
                                (user.onboarding &&
                                    user.onboarding.completedSteps &&
                                    !user.onboarding.completedSteps.includes('create-card')))) {
                            onboarding_web_1.completeStep(db, user.id, 'create-card');
                        }
                        // Add time spent creating card to deck analytics
                        deck.addAnalyticsEvent({
                            type: 'create-card',
                            card: cardId,
                            time: time,
                        });
                        user.incrementStatistic('cards-created');
                        user.incrementStreak();
                        // Log the event to analytics
                        logEvent('create_card', {
                            type: deck.roles.includes('student') ? 'personal' : 'normal',
                        });
                        user.updateLastActivityTimestamp();
                        setLoading(false);
                        if (resetOnSuccess) {
                            reset();
                        }
                        if (onSuccess) {
                            onSuccess(cardId);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    var openImportDialog = react_1.useCallback(function () {
        importMenuPopupState.close();
        setImportDialogOpen(true);
    }, [importMenuPopupState]);
    var closeImportDialog = react_1.useCallback(function () {
        setImportDialogOpen(false);
    }, []);
    var openQuizletDialog = react_1.useCallback(function () {
        importMenuPopupState.close();
        setQuizletDialogOpen(true);
    }, [importMenuPopupState]);
    var closeQuizletDialog = react_1.useCallback(function () {
        setQuizletDialogOpen(false);
    }, []);
    var openCsvDialog = react_1.useCallback(function () {
        importMenuPopupState.close();
        setCsvDialogOpen(true);
    }, [importMenuPopupState]);
    var closeCsvDialog = react_1.useCallback(function () {
        setCsvDialogOpen(false);
    }, []);
    var showImportSuccessMessage = react_1.useCallback(function (count) {
        setSnackbarMessage(count + " card" + (count > 1 && 's') + " successfully imported");
        setSnackbarOpen(true);
    }, []);
    var handleImportQuizlet = react_1.useCallback(function (text, rowSeparator, columnSeparator) { return __awaiter(void 0, void 0, void 0, function () {
        var cards, rowSeparatorFixed, columnSeparatorFixed, rows;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    cards = [];
                    rowSeparatorFixed = rowSeparator.split('\\n').join('\n');
                    columnSeparatorFixed = columnSeparator.split('\\n').join('\n');
                    rows = text.split(rowSeparatorFixed);
                    rows.forEach(function (row) {
                        var rowParts = row.split(columnSeparatorFixed);
                        if (rowParts[0] && rowParts[1]) {
                            cards.push({
                                id: uuid_1.v4(),
                                question: editor_web_1.serializeDocument(editor_web_1.generateRichTextDocument([rowParts[0]])),
                                answer: editor_web_1.serializeDocument(editor_web_1.generateRichTextDocument([rowParts[1]])),
                            });
                        }
                    });
                    return [4 /*yield*/, deck.addCardBatch(cards)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    closeQuizletDialog();
                    showImportSuccessMessage(cards.length);
                    return [2 /*return*/];
            }
        });
    }); }, [closeQuizletDialog, deck, showImportSuccessMessage]);
    // const handleImportCsv = useCallback(
    //   async (text: string, file: File | null) => {
    //     setLoading(true);
    //     let cards: DeckAddCardBatchItem[] = [];
    //     const createCards = (rows: string[][]): DeckAddCardBatchItem[] =>
    //       rows
    //         .map(
    //           (row: string[]): DeckAddCardBatchItem => ({
    //             question: row[0],
    //             answer: row[1],
    //             explanation: row[2],
    //             summary: row[3],
    //           }),
    //         )
    //         .filter(card => card.question && card.answer);
    //     if (file) {
    //       Papa.parse(file, {
    //         delimiter: ',',
    //         complete: async result => {
    //           cards = createCards(result.data);
    //           await deck.addCardBatch(cards);
    //           setLoading(false);
    //           closeCsvDialog();
    //           showImportSuccessMessage(cards.length);
    //         },
    //       });
    //     } else if (text) {
    //       const result = Papa.parse(text, { delimiter: ',' });
    //       cards = createCards(result.data);
    //       await deck.addCardBatch(cards);
    //       setLoading(false);
    //       closeCsvDialog();
    //       showImportSuccessMessage(cards.length);
    //     }
    //   },
    //   [closeCsvDialog, deck, showImportSuccessMessage],
    // );
    var handleClose = react_1.useCallback(function (event, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    }, []);
    var actionButtons = [
        react_1.default.createElement(Button_1.default, { type: "submit", variant: "contained", color: "primary", size: "large", disabled: loading || uploads.length > 0 }, "Create"),
    ];
    if (typeof onCancel === 'function') {
        actionButtons.unshift(react_1.default.createElement(Button_1.default, { size: "large", onClick: onCancel, disabled: loading }, "Cancel"));
    }
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(CardFormContainer_1.default, __assign({ onSubmit: handleSubmit, actionButtons: actionButtons, secondaryAction: react_1.default.createElement(core_2.Hidden, { only: "xs" },
                react_1.default.createElement(Button_1.default, __assign({ style: { paddingTop: 12, paddingBottom: 12 }, variant: "text", size: "large" }, hooks_1.bindTrigger(importMenuPopupState)),
                    "Import cards ",
                    react_1.default.createElement(ArrowDropDownRounded_1.default, null))) }, other)),
        react_1.default.createElement(core_2.Menu, __assign({}, hooks_1.bindMenu(importMenuPopupState)),
            react_1.default.createElement(core_2.MenuItem, { onClick: openImportDialog }, "Import from another deck"),
            react_1.default.createElement(core_2.MenuItem, { onClick: openQuizletDialog }, "Import from Quizlet"),
            react_1.default.createElement(core_2.MenuItem, { onClick: openCsvDialog }, "Import from CSV")),
        react_1.default.createElement(ImportCardsDialog_1.default, { open: importDialogOpen, onClose: closeImportDialog }),
        react_1.default.createElement(DeckImportFromQuizletContainer_1.default, { loading: loading, open: quizletDialogOpen, onClose: closeQuizletDialog, onCancel: closeQuizletDialog, onSubmit: handleImportQuizlet }),
        react_1.default.createElement(cards_web_1.ImportFromCsvDialog, __assign({}, { db: db, storage: storage, functions: functions }, { open: csvDialogOpen, onClose: closeCsvDialog, createCards: deck.addCardBatch }))));
};
exports.default = CreateCardFormContainer;
//# sourceMappingURL=CreateCardFormContainer.js.map